module.exports = __webpack_public_path__ + "static/media/038-toothpaste.5baa7517.svg";